import React, { useState } from "react";
import { collection, addDoc, query, where, getDocs } from "firebase/firestore";
import { db } from "./firebase";
import "./styles.css";

const LABEL_OPTIONS = [
  "Aerospace", "Architectural", "Biomedical", "Chemical", "Civil",
  "Computer", "Consulting", "Cyber Security", "Defense/Security", "Design", "Electrical",
  "Electronic Systems", "Energy (Oil/Gas/Renewables)", "Environmental",
  "Industrial", "Manufacturing", "Materials Science", "Mechanical", "Nuclear",
  "Ocean", "Petroleum", "Pharmaceuticals", "Program Management", "Research",
  "Software", "Startups"
];

function InternForm() {
  const [formData, setFormData] = useState({
    name: "", major: "", graduation: "", company: "", role: "", location: "",
    session: "", applicationDate: "", offerDate: "", contact: "", shareContact: false, labels: [], labelSuggestion: "",
    description: "", how:"", memberID: "", contactRemovalYear: "", source: "", uin: "", sweEmail: "", tamuEmail: ""
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "labels") {
      setFormData((prev) => ({
        ...prev,
        labels: checked
          ? [...prev.labels, value]
          : prev.labels.filter((label) => label !== value),
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.labels.length > 3) {
      alert("You can select up to 3 labels only.");
      return;
    }

    const duplicateQuery = query(
      collection(db, "internships"),
      where("name", "==", formData.name),
      where("company", "==", formData.company),
      where("session", "==", formData.session)
    );
    const duplicateSnapshot = await getDocs(duplicateQuery);
    if (!duplicateSnapshot.empty) {
      alert("An entry with this name, company, and session already exists.");
      return;
    }

    try {
      await addDoc(collection(db, "internships"), {
        ...formData,
        approved: false,
      });
      alert("Your submission was sent for officer approval!");
      setFormData({
        name: "", major: "", graduation: "", company: "", role: "", location: "",
        session: "", applicationDate: "", offerDate: "", contact: "", shareContact: false, labels: [], labelSuggestion: "",
        description: "", memberID: "", contactRemovalYear: "", source: "", uin: "", sweEmail: "", tamuEmail: ""
      });
    } catch (error) {
      console.error("Error submitting form: ", error);
      alert("There was an error submitting. Please try again. If the issue persists, please email membership@swetamu.org.");
    }
  };

  return (
    <div className="form-background">
      <form onSubmit={handleSubmit} className="swe-form">
        <h2>SWE Internship Submission</h2>

        <div className="form-grid">
          <label>Name:</label>
          <input name="name" value={formData.name} onChange={handleChange} required placeholder="First and Last Name" />

          <label>Major:</label>
          <input name="major" value={formData.major} onChange={handleChange} required placeholder="Four Letter Code. Ex: MEEN or ENGR" />

          <label>Graduation:</label>
          <input name="graduation" value={formData.graduation} onChange={handleChange} required placeholder="Ex: 2026" />

          <label>Company:</label>
          <input name="company" value={formData.company} onChange={handleChange} required />

          <label>Internship/Co-Op Role:</label>
          <input name="role" value={formData.role} onChange={handleChange} required />

          <label>Location:</label>
          <input name="location" value={formData.location} onChange={handleChange} required placeholder="Ex: Dallas, TX or Remote" />

          <label>Session:</label>
          <input name="session" value={formData.session} onChange={handleChange} required placeholder="Ex: Summer 2025" />

          <label>Approximately when did you apply for this internship? (Month Year)</label>
          <input name="applicationDate" value={formData.applicationDate} onChange={handleChange} required placeholder="Ex: August 2024" />

          <label>Approximately when did you receive your offer for this internship? (Month Year)</label>
          <input name="offerDate" value={formData.offerDate} onChange={handleChange} required placeholder="Ex: November 2024" />

        <label>
          What did you do during your internship/co-op?</label>
          <textarea name="description" value={formData.description} onChange={handleChange} required placeholder="Ex: Worked on simulations for aircraft cooling systems. Analyzed test data for mechanical tolerances." />
        

        <label>
          How did you get your internship? </label>
          <select name="source" value={formData.source} onChange={handleChange} required>
            <option value="">-- Select One --</option>
            <option value="Career Fair (at TAMU)">Career Fair (at TAMU)</option>
            <option value="Career Fair (outside TAMU)">Career Fair (outside TAMU)</option>
            <option value="Personal Network">Personal Network</option>
            <option value="Online Application">Online Application</option>
            <option value="Other">Other</option>
          </select>
        

        <label>SWE Member ID (not shared):</label>
        <input name="memberID" value={formData.memberID} onChange={handleChange} placeholder="Optional" />

        <label>UIN (only required if you would like a SWE point for this submission):</label>
        <input
          name="uin"
          value={formData.uin}
          onChange={handleChange}
          placeholder = "Optional"
          />

        <label>Societal SWE Email (only required if you would like a SWE point for this submission):</label>
        <input
          name="sweEmail"
          value={formData.sweEmail}
          onChange={handleChange}
          placeholder = "Optional"
          />
        <label>TAMU Email (only required if you would like a SWE point for this submission):</label>
        <input
          name="tamuEmail"
          value={formData.tamuEmail}
          onChange={handleChange}
          placeholder = "Optional"
          />

<label>Contact:</label>
          <input name="contact" value={formData.contact} onChange={handleChange} required placeholder="LinkedIn URL or personal email. Put N/A if you don't want to share." />
        </div>

        <label className="checkbox-align">
          <input type="checkbox" name="shareContact" checked={formData.shareContact} onChange={handleChange} />
          If you agree to share your contact information, please check here. If not, leave this box unchecked.
        </label>

        <label>If you would like your contact information to be removed in the future, please input approximately when you would like it removed.</label>
        <select name="contactRemovalYear" value={formData.contactRemovalYear || ""} onChange={handleChange}>
          <option value="">No removal</option>
          {Array.from({ length: 15 }, (_, i) => new Date().getFullYear() + i).map(year => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>

        <label>
          Select Engineering Labels (Max 3):
          <div className="labels-grid">
            {LABEL_OPTIONS.map((label) => (
              <label key={label} className={`label-box ${formData.labels.includes(label) ? "selected" : ""}`}>
                <input
                  type="checkbox"
                  name="labels"
                  value={label}
                  checked={formData.labels.includes(label)}
                  onChange={handleChange}
                  disabled={!formData.labels.includes(label) && formData.labels.length >= 3}
                />
                {label}
              </label>
            ))}
          </div>
        </label>

        <label>
          Don’t see a good label? Suggest one:
          <input name="labelSuggestion" value={formData.labelSuggestion} onChange={handleChange} />
        </label>

        <button type="submit">Submit</button>
      </form>
    </div>
  );
}

export default InternForm;
